import { useEffect, useState } from "react";
import Skeleton from "react-loading-skeleton";
import { useDispatch } from "react-redux";
import {
  useLocation,
  useParams
} from "react-router-dom";
import useFetch from "../../../hook/useFetch";
import useFilter from "../../../hook/useFilter";
import useIsMobile from "../../../hook/useIsMobile";
import { favoriteActions } from "../../../store/favorite-slice";
import { notificationActions } from "../../../store/notification-slice";
import { productActions } from "../../../store/products-slice";
import { userActions } from "../../../store/user-slice";
import DesktopComponent from "./datatable/desktop";
import MobileComponent from "./datatable/mobile";
import ProductDetails from "./productdetails";

export default function Products() {
  const { get } = useFetch();
  const [products, setProducts] = useState();
  let dispatch = useDispatch();
  const { convertToArray } = useFilter();

  const { id } = useParams();

  const [favorites, setFavorites] = useState();

  let location = useLocation();

  const fetchData = () => {
    setFavorites(null);
    setProducts(null);
    dispatch(favoriteActions.resetFavorites());
    dispatch(productActions.resetProducts());
    get(
      "/products",
    null,
      (data) => {
        dispatch(
          notificationActions.setNotification({
            message: data,
            status: false,
          }),
        );
      },
      (data) => {
        data = convertToArray(data);
        setProducts(data);
        dispatch(productActions.setProducts(data));
      },
    );

    get(`/favorites`, null, null, (data) => {
      setFavorites(data);
      dispatch(favoriteActions.setFavorites(data));
    });

    get(`/orders`, null, null, (data) => {
      dispatch(userActions.setOrders(data));
    });
  };
  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    if (location.state && location.state.refetch) {
      fetchData();
    }
  }, [location.state]);

  const { isMobile } = useIsMobile();

  if (!products || !favorites) {
    return <Skeleton count={50} />;
  }

  if (id) {
    return <ProductDetails id={id} />;
  }

  return (
    <div className="rso-pages card shadow  bg-white rounded p-3 m-0">
      {isMobile ? <MobileComponent /> : <DesktopComponent />}
    </div>
  );
}
